
// SE DISPARA SOLO LA PRIMERA VEZ
export default (activator: string, selector: string, callback: (elm: Element) => void) => {
    const threshold: number = activator == 'top' ? 0.2 : activator == 'center' ? 0.5 : 1;
    const options: object = { threshold }
    const DOMElm: Element = document.querySelector(selector)
    let localCompleted: boolean = true

    if (DOMElm) {
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && localCompleted) {
                    localCompleted = false
                    callback(DOMElm)
                }
            });

        }, options)
        observer.observe(DOMElm)
    }
}


export const ScrollTriggerAll = (activator: string, selector: string, callback: (elm: Element) => void) => {
    const threshold: number = activator == 'top' ? 0.2 : activator == 'center' ? 0.5 : 1;
    const options: object = { threshold }
    const DOMElm: NodeListOf<Element> = document.querySelectorAll(selector)

    if (DOMElm.length > 0) {
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    callback(entry.target)
                }
            });

        }, options)

        for (let i = 0; i < DOMElm.length; i++) {
            const listElm = DOMElm[i];
            observer.observe(listElm)
        }
    }
}